// extracted by css-extract-rspack-plugin
export default {"container":"Metadata-module__container__epfvu","heading":"Metadata-module__heading__wNSXP"};